export enum rocketChatRemove {
    isRemove  = "true"
}
